import { render, staticRenderFns } from "./IncidentRecord.vue?vue&type=template&id=8a20f760&scoped=true"
import script from "./IncidentRecord.vue?vue&type=script&lang=js"
export * from "./IncidentRecord.vue?vue&type=script&lang=js"
import style0 from "./IncidentRecord.vue?vue&type=style&index=0&id=8a20f760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a20f760",
  null
  
)

export default component.exports